import { createEntityAdapter } from "@reduxjs/toolkit";
import { Patient } from "@/redux/slice/auth/types/Patient";

export default createEntityAdapter({
  selectId: (patient: Patient) => patient.id,
});
